import { apiCall } from './gqlClient';
const GOOGLEMEETCHECKIFPROVIDERCONNECTED_QUERY = "\n  query googleMeetCheckIfProviderConnected {\n    googleMeetCheckIfProviderConnected\n  }";
export const googleMeetCheckIfProviderConnectedApiCall = async () => apiCall({
  query: GOOGLEMEETCHECKIFPROVIDERCONNECTED_QUERY,
  variables: {}
});
const DISCONNECTGOOGLEMEET_QUERY = "\n  mutation disconnectGoogleMeet {\n    disconnectGoogleMeet\n    {\n      success\n\t\t\tmessage\n\t\t\tid\n\t\t\tid2\n\t\t\tname\n\t\t\tstatus\n      ...fragments\n    }\n  }";
export const disconnectGoogleMeetApiCall = async function () {
  let fragments = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  return apiCall({
    query: DISCONNECTGOOGLEMEET_QUERY,
    variables: {},
    fragments
  });
};
const CANCELGOOGLEMEET_QUERY = "\n  mutation cancelGoogleMeet($eventId: String!, $pId: Int) {\n    cancelGoogleMeet(eventId: $eventId, pId: $pId)\n    {\n      success\n\t\t\tmessage\n\t\t\tid\n\t\t\tname\n\t\t\tidx\n\t\t\ttitle\n      ...fragments\n    }\n  }";
export const cancelGoogleMeetApiCall = async function (_ref) {
  let {
    eventId,
    pId
  } = _ref;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: CANCELGOOGLEMEET_QUERY,
    variables: {
      eventId,
      pId
    },
    fragments
  });
};
const CREATEGOOGLEMEET_QUERY = "\n  mutation createGoogleMeet($start: JSON!, $end: JSON!, $description: String!, $isUtc: Boolean) {\n    createGoogleMeet(start: $start, end: $end, description: $description, isUtc: $isUtc)\n    {\n      id\n\t\t\turi\n      ...fragments\n    }\n  }";
export const createGoogleMeetApiCall = async function (_ref2) {
  let {
    start,
    end,
    description,
    isUtc
  } = _ref2;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: CREATEGOOGLEMEET_QUERY,
    variables: {
      start,
      end,
      description,
      isUtc
    },
    fragments
  });
};
const UPDATEGOOGLEMEET_QUERY = "\n  mutation updateGoogleMeet($start: JSON!, $end: JSON!, $eventId: String!, $isUtc: Boolean) {\n    updateGoogleMeet(start: $start, end: $end, eventId: $eventId, isUtc: $isUtc)\n    {\n      id\n\t\t\turi\n      ...fragments\n    }\n  }";
export const updateGoogleMeetApiCall = async function (_ref3) {
  let {
    start,
    end,
    eventId,
    isUtc
  } = _ref3;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: UPDATEGOOGLEMEET_QUERY,
    variables: {
      start,
      end,
      eventId,
      isUtc
    },
    fragments
  });
};